import React, { useEffect, useState } from "react";
import SC from "./style";
import {
  Breadcrumbs,
  DetailDrawer,
  InnoTable,
  Popover,
  TableList,
} from "InnoUI/components";
import { useLocation, useNavigate } from "react-router";
import { Switch } from "antd";
import theme from "theme";
import { apiGet, apiPost } from "api/callApi";
import AddLevel from "../AddLevel";
import { ImagePreview } from "components";
import { showAlert } from "utils/helper";
import DeleteComponent from "views/AdminSettings/DeleteComponent";
import { innoTableConfigsecond, InnoTableDefaultPageSize } from "utils/config";
import { projectType } from "utils/lookUpTable";

const ProjectsLevel = ({ popupState }) => {
  const location = useLocation();
  const { data } = location.state || {};

  const [projects, setProjects] = useState([]);
  const [open, setOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [rowData, setRowData] = useState();
  const [rowId, setRowId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [openDeleteView, setOpenDeleteView] = useState(false);
  const [fieldId, setFieldId] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(InnoTableDefaultPageSize.pageSize);

  const navigate = useNavigate();

  const namerole = data ? data.propertyName : "Default Name";

  const breadcrumbItems = [
    { label: "Admin Settings" },
    { label: "Projects", href: "/admin-settings/projects" },
    {
      label: `${data?.propertyName || ""}`,
      href: "/admin-settings/projects/level",
    },
  ];

  const handleBreadcrumbClick = (href) => {
    if (href) {
      navigate(href, { state: { data } });
    }
  };

  const getAllProjects = async () => {
    try {
      setIsLoading(true);
      const response = await apiGet(`/v1/${data.id}/levels`, false);
      setProjects(response.data);
      setIsLoading(false);
    } catch (error) {
      console.log("error", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllProjects();
  }, []);

  const handleChange = async (id, property, value) => {
    try {
      const endpoint = `/v1/levels/${id}`;
      const response = await apiPost(endpoint, { [property]: value });
      setProjects((prevProjects) =>
        prevProjects.map((project) =>
          project.id === id ? { ...project, [property]: value } : project
        )
      );
      showAlert({ title: "Success", text: response.message, icon: "success" });
    } catch (error) {
      console.error("Error updating status:", error);
      showAlert({
        title: "Error",
        text: "Failed to update status",
        icon: "error",
      });
    }
  };

  const closeDrawer = () => {
    setOpen(false);
    setIsEditing(false);
  };

  const onAddDataCallback = () => {
    setOpen(true);
    setRowData("");
    setIsEditing(false);
  };

  const onRowClick = (data) => {
    setIsEditing(true);
    setRowData(data);
    setOpen(true);
    setRowId(data.id);
  };

  const handlelevelClick = (rowAllData) => {
    navigate(`/admin-settings/projects/occupant`, {
      state: { rowAllData, data },
    });
  };

  const handleDeleteOpenModal = (record) => {
    setFieldId(record?.id);
    setRowData(record);
    setOpenDeleteView(true);
  };

  const handleDelete = async (levelId) => {
    try {
      const body = {
        projectId: levelId,
        projectType: projectType.level,
      };
      const response = await apiPost(`/v1/deleterequest`, body, false);
      showAlert({ title: "Success", text: response.message, icon: "success" });
      getAllProjects();
      setOpenDeleteView(false);
    } catch (error) {
      console.log(error.message);
    }
  };

  const subColumnData = [
    {
      title: "S.No.",
      dataIndex: "id",
      width: 80,
      render(value, record, index) {
        // const pageSize = innoTableConfigsecond.pageSize;
        const serialNumber = (currentPage - 1) * pageSize + index + 1;
        return <SC.ValueSpan>{serialNumber}</SC.ValueSpan>;
      },
    },

    {
      title: "Level Name",
      dataIndex: "name",
      // sorter: (a, b) => a.name.localeCompare(b.name),
      // showSorterTooltip: { target: "sorter-icon" },
      // sortDirections: ["ascend", "descend"],
      onCell: () => ({
        style: { width: "350px" },
      }),
      render(value, record) {
        const menuItems = [
          {
            id: 1,
            text: "Open",
            onClick: () => handlelevelClick(record),
          },
          {
            id: 2,
            text: "Edit",
            onClick: (event) => {
              event.stopPropagation();
              onRowClick(record);
            },
          },
          {
            id: 3,
            text: "Delete",
            onClick: (event) => {
              event.stopPropagation();
              handleDeleteOpenModal(record);
            },
          },
        ];
        return (
          <SC.PopoverContainer>
            <SC.ValueSpanp>{value}</SC.ValueSpanp>
            <Popover
              sx={{
                cursor: "pointer",
              }}
              buttonLabel={{
                icon: (
                  <>
                    <div
                      style={{
                        width: "50px",
                        textAlign: "center",
                        justifyContent: "end",
                        display: "flex",
                        marginRight: "5px",
                      }}
                    >
                      <SC.PopoverSpan>
                        <SC.MoreVertIcon />
                      </SC.PopoverSpan>
                    </div>
                  </>
                ),
              }}
              popoverContent={
                <TableList
                  sx={{
                    borderBottom: `1px solid ${theme.colors.bordertask}`,
                  }}
                  items={menuItems || []}
                  popupState={popupState}
                />
              }
            />
          </SC.PopoverContainer>
        );
      },
    },
    {
      title: "Property Name",
      dataIndex: "propertyName",
      render(value, record, index) {
        return (
          <>
            <SC.ValueSpan>{data.propertyName}</SC.ValueSpan>
          </>
        );
      },
    },
    {
      title: "Total Occupants",
      dataIndex: "totalOccupantCount",
      render(value, record, index) {
        return (
          <SC.PopoverContainer>
            <SC.ValueSpanp
              style={{
                color: "#eb7909",
                opacity: "0.7",
                textAlign: "center",
                cursor: "pointer",
                textDecoration: "underline",
                fontWeight: "bold",
              }}
              onClick={(event) => {
                event.stopPropagation();
                handlelevelClick(record);
              }}
            >
              {value}
            </SC.ValueSpanp>
          </SC.PopoverContainer>
        );
      },
    },
    {
      title: "Images",
      dataIndex: "image",
      render(value, record, index) {
        return (
          <>
            <ImagePreview width={40} src={`${value}`} />
          </>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (value, record) => (
        <Switch
          checked={value}
          onChange={(checked, event) => {
            event.stopPropagation();
            handleChange(record.id, "status", checked ? 1 : 0);
          }}
          style={{
            transform: "scale(0.7)",
            backgroundColor: value ? `${theme.colors.themeColor}` : undefined,
            borderColor: value ? `${theme.colors.themeColor}` : undefined,
          }}
        />
      ),
    },
  ];

  const tableConfig = {
    draggable: false,
    selection: false,
    expandable: true,
    addNew: true,
    search: true,
    pagination: {
      current: currentPage, // current page number
      pageSize: pageSize, // page size state
      // pageSizeOptions: ["20", "50", "100"], // options shown in the dropdown
      // showSizeChanger: true, // enable page size dropdown
      onChange: (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize); // this is important to update
      },
    },
    action: false,
    divBorder: true,
    sno: false,
    searchPlaceholder: "Search by Name",
  };

  return (
    <>
      <Breadcrumbs
        items={breadcrumbItems}
        separator=">"
        currentPath={location.pathname}
        onClick={handleBreadcrumbClick}
      />

      <SC.BodyContainer>
        <div
          style={{
            width: "200px",
            height: "130px",
            borderRadius: "8px",
            overflow: "hidden",
            margin: "60px 20px 10px 25px",
            border: `3px solid ${theme.colors.greyColor}`,
          }}
        >
          <ImagePreview
            src={data?.logoImage}
            height={"100%"}
            width={"100%"}
            style={{ objectFit: "contain" }}
          />
        </div>

        <SC.Container>
          <InnoTable
            tableConfig={tableConfig}
            padding="4px 8px"
            column={subColumnData}
            data={projects}
            tableKey="Level"
            ComponnentName={namerole + " /Levels"}
            searchKeys={["name", "propertyName"]}
            onRowClickCallback={onRowClick}
            onAddDataCallback={onAddDataCallback}
            loading={isLoading}
            onRow={(record) => ({
              onClick: (event) => {
                setTimeout(() => {
                  if (!document.querySelector(".ant-image-preview-mask")) {
                    handlelevelClick(record);
                  }
                }, 100);
              },
            })}
          />
        </SC.Container>
      </SC.BodyContainer>
      {open && (
        <DetailDrawer
          open={open}
          onClose={closeDrawer}
          title={false}
          width={"650px"}
          children={
            <AddLevel
              projectdata={rowData}
              onClose={closeDrawer}
              isEditing={isEditing}
              setIsEditing={setIsEditing}
              rowId={rowId}
              projectId={data.id}
              setProjects={setProjects}
            />
          }
        />
      )}

      {openDeleteView && (
        <DeleteComponent
          title={"Delete User"}
          messageData={`Are you sure you want to delete user ${
            rowData?.propertyName || ""
          }?`}
          setOpenDeleteView={setOpenDeleteView}
          openDeleteView={openDeleteView}
          handleDelete={() => handleDelete(fieldId)}
          handleArchive={() => setOpenDeleteView(false)}
          firstButtontext={"Cancel"}
        />
      )}
    </>
  );
};

export default ProjectsLevel;
